import { useDispatch } from "react-redux";
import { TRACK_REPORT_SCREEN_VIEW, TRACK_REPORTS_TOGGLED_VIEW_EVENT, TRACK_REPORTS_VIEWED_EVENT } from "src/constants/adoption/eventTypes";
import { trackEventForAdoption } from "../adoption";
import { ReportScreenViewRequest, ReportsToggledViewRequest, ReportsViewedRequest } from "src/types/adoption/reports";

export const useReportsAdoption = () => {
  const dispatch = useDispatch();

  // reports toggled view
  const trackReportsToggledView = ({ tabType }: ReportsToggledViewRequest) => {
    const event = {
      event: TRACK_REPORTS_TOGGLED_VIEW_EVENT,
      properties: {
        tab_type: tabType,
      },
    };
    dispatch(trackEventForAdoption(event));
  };


  // Track report screen view
  const trackReportScreenView = ({ sourceCta }: ReportScreenViewRequest) => {
    const event = {
      event: "Page Viewed",
      properties: {
        screen_name: TRACK_REPORT_SCREEN_VIEW,
        source_cta: sourceCta,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  // Track reports viewed
  const trackReportsViewed = ({ sourceCta }: ReportsViewedRequest) => {
    const event = {
      event: TRACK_REPORTS_VIEWED_EVENT,
      properties: {
        source_cta: sourceCta,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  return {
    trackReportsToggledView,
    trackReportScreenView,
    trackReportsViewed
  };
};